import { render, staticRenderFns } from "./TripBox.vue?vue&type=template&id=714c5d84"
import script from "./TripBox.vue?vue&type=script&lang=js"
export * from "./TripBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports